import mapboxgl from "mapbox-gl";
import * as turf from '@turf/turf';

import { MapCheckpoint } from "../interfaces/map-checkpoint";

export const addCheckpointsOnMap = (map: mapboxgl.Map, coords: MapCheckpoint[], identification: string, color?: string) => {
    const checkpointsId = identification + '-checkpoints';
    const checkpointsPointLayerId = identification + '-checkpoints-point';
    const checkpointsLabelLayerId = identification + '-checkpoints-label';
    const checkpointsShapeLayerId = identification + '-checkpoints-shape';

    const features = [] as any;
    const shapes = [] as any;

    for (const coord of coords) {
        const feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': coord.coordinate
            },
            'properties': {
                'title': coord.name
            }
        }

        features.push(feature);

        const center = turf.point([coord.coordinate[0], coord.coordinate[1]]);
        const radius = (coord.radio ?? 30) / 1000;
        const circle = turf.circle(center, radius);

        shapes.push(circle);
    }

    const sourceData: any = {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': features
        }
    };

    map.addSource(checkpointsId, sourceData);

    const pointLayer: mapboxgl.AnyLayer = {
        id: checkpointsPointLayerId,
        type: "circle",
        source: checkpointsId,
        paint: {
            'circle-radius': 8,
            'circle-color': color ?? '#4264fb'
        }
    }

    const textLayer: mapboxgl.AnyLayer = {
        id: checkpointsLabelLayerId,
        type: 'symbol',
        source: checkpointsId,
        layout: {
            'text-field': ['get', 'title'],
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 1.5],
            'text-anchor': 'center',
            'text-size': 12,
            'text-allow-overlap': true
        }
    };

    map.addLayer(pointLayer);
    map.addLayer(textLayer);

    const sourceShape: any = {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': shapes
        }
    };

    map.addSource(checkpointsShapeLayerId, sourceShape);

    const shape: mapboxgl.AnyLayer = {
        id: checkpointsShapeLayerId,
        type: "fill",
        source: checkpointsShapeLayerId,
        paint: {
            "fill-color": 'yellow',
            "fill-opacity": 0.5
        }
    }

    map.addLayer(shape);
}

export const deleteCheckpoints = (map: mapboxgl.Map, identification: string) => {
    const checkpointsId = identification + '-checkpoints';
    const checkpointsPointLayerId = identification + '-checkpoints-point';
    const checkpointsLabelLayerId = identification + '-checkpoints-label';
    const checkpointsShapeLayerId = identification + '-checkpoints-shape';

    if (map.getLayer(checkpointsId)) {
        map.removeLayer(checkpointsId);
    }

    if (map.getLayer(checkpointsPointLayerId)) {
        map.removeLayer(checkpointsPointLayerId);
    }

    if (map.getLayer(checkpointsLabelLayerId)) {
        map.removeLayer(checkpointsLabelLayerId);
    }

    if (map.getLayer(checkpointsShapeLayerId)) {
        map.removeLayer(checkpointsShapeLayerId);
    }

    if (map.getSource(checkpointsId)) {
        map.removeSource(checkpointsId);
    }

    if (map.getSource(checkpointsShapeLayerId)) {
        map.removeSource(checkpointsShapeLayerId);
    }
}